module.exports = __webpack_public_path__ + "media/src/assets/images/about_solution-pic5-adfffda98a37f775da03a8a194a40815.png";